<template>
    <button
        type="button"
        class="c-btn"
        :style="rootStyle"
        :disabled="disabled"
        @click="onClick"
        @mousedown="onMouseDown"
        @mouseup="onMouseUp"
        @mouseleave="onMouseUp"
    >
        <slot />
    </button>
</template>

<script>
import { C_INK, C_HAIR, FONT_BODY } from './tokens';

export default {
    name: 'CBtn',
    props: {
        primary: { type: Boolean, default: false },
        ghost: { type: Boolean, default: false },
        big: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        // Extra inline styles for per-call overrides (e.g. background: C_RED).
        extraStyle: { type: Object, default: () => ({}) },
    },
    computed: {
        rootStyle() {
            return {
                padding: this.big ? '16px 32px' : '12px 22px',
                border: `1px solid ${
                    this.primary ? C_INK : this.ghost ? 'transparent' : C_HAIR
                }`,
                background: this.primary ? C_INK : this.ghost ? 'transparent' : '#fff',
                color: this.primary ? '#fff' : C_INK,
                borderRadius: '999px',
                fontFamily: FONT_BODY,
                fontSize: this.big ? '16px' : '14px',
                fontWeight: 600,
                letterSpacing: '-0.1px',
                cursor: this.disabled ? 'not-allowed' : 'pointer',
                opacity: this.disabled ? 0.4 : 1,
                transition: 'transform 80ms, background 120ms',
                ...this.extraStyle,
            };
        },
    },
    methods: {
        onClick(event) {
            if (this.disabled) return;
            this.$emit('click', event);
        },
        onMouseDown(event) {
            if (this.disabled) return;
            event.currentTarget.style.transform = 'translateY(1px)';
        },
        onMouseUp(event) {
            event.currentTarget.style.transform = 'translateY(0)';
        },
    },
};
</script>
